import React from 'react';
import { ASSIGNEE_FILTER_ADD_PEOPLE_BUTTON_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import type { QuickstartNudgeWrapperBaseProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AssigneeFilterAddPeopleButtonLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-assignee-filter-add-people-nudge" */ './index'
		).then((exportedModule) => exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge),
	{
		ssr: false,
	},
);
export const AssigneeFilterAddPeopleButtonWrapperNudgeAsync = ({
	children,
}: QuickstartNudgeWrapperBaseProps): React.JSX.Element => (
	<OnboardingNudgeErrorBoundary
		id={ASSIGNEE_FILTER_ADD_PEOPLE_BUTTON_NUDGE_ID}
		fallback={children}
		attributes={{
			nudgeId: ASSIGNEE_FILTER_ADD_PEOPLE_BUTTON_NUDGE_ID,
		}}
	>
		<Placeholder
			name="software-onboarding-assignee-filter-add-people-nudge"
			fallback={<>{children}</>}
		>
			<AssigneeFilterAddPeopleButtonLazy nudgeId={ASSIGNEE_FILTER_ADD_PEOPLE_BUTTON_NUDGE_ID}>
				{children}
			</AssigneeFilterAddPeopleButtonLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
